import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import {
	provideClientHydration,
	withEventReplay
} from '@angular/platform-browser';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { errorInterceptor } from './shared/interceptors/error.interceptor';
import { spinnerInterceptor } from './shared/interceptors/spinner.interceptor';
//import { requestIdInterceptor } from './shared/interceptors/request-id.interceptor';

function getBaseUrl() {
	let baseUrl = document.getElementsByTagName('base')[0].href;

	if (baseUrl && (baseUrl.endsWith('\\') || baseUrl.endsWith('/')))
		baseUrl = baseUrl.substring(0, baseUrl.length - 1);
	return baseUrl;
}

export const appConfig: ApplicationConfig = {
	providers: [
		provideZoneChangeDetection({ eventCoalescing: true }),
		provideRouter(routes),
		{
			provide: 'BASE_URL',
			useFactory: getBaseUrl
		},
		provideClientHydration(withEventReplay()),
		provideHttpClient(
			withInterceptors([
				//requestIdInterceptor,
				errorInterceptor,
				spinnerInterceptor
			])
		)
	]
};
